import { Box } from '@mui/material';
import CampaignListTable from './CampaignListTable';

const ManageCampaign = () => {
	return (
		<Box className="mb-14 w-full">
			<CampaignListTable />
		</Box>
	);
};

export default ManageCampaign;
